angular.module('AccountingBoxApp')
    .factory('Auth', function Auth($rootScope, User) {
        var currentUser = null;
        return {
             /**
             * Refreshes the authenticated user information
             *
             * @pararm {Object} user
             */
            refreshCurrentUser: function(cb) {
                currentUser = User.getCurrent(function (user) {
                    cb(user);
                });

            },

            /**
             * Sets all available info on authenticated user
             *
             * @pararm {Object} user
             */
            setCurrentUser: function(user) {
                //console.log('currentuser:');
                //console.log(currentUser);
                currentUser = user;
            },
            /**
             * Gets all available info on authenticated user
             *
             * @return {Object} user
             */
            getCurrentUser: function() {
                //console.log('currentuser:');
                //console.log(currentUser);
                return JSON.parse(JSON.stringify(currentUser));
            },

            /**
             * Check if a user is logged in
             *
             * @return {Boolean}
             */
            isLoggedIn: function() {
                //   console.log('2222');

                return User.isAuthenticated();
            },

            /**
             * Waits for currentUser to resolve before checking if user is logged in
             */
            /* isLoggedInAsync: function(cb) {
               if(currentUser.hasOwnProperty('$promise')) {
                 currentUser.$promise.then(function() {
                   cb(true);
                 }).catch(function() {
                   cb(false);
                 });
               } else if(currentUser.hasOwnProperty('role')) {
                 cb(true);
               } else {
                 cb(false);
               }
             },*/

            /**
             * Check if a user is a bookkeeper
             *
             * @return {Boolean}
             */
            isBookkeeper: function() {
                //  console.log('4444');
                // var user = User.getCurrent();
                // console.log('user:',user);
                if(!currentUser) return false;

                return currentUser.isBookkeeper;
                // return false;
            },

            /**
             * Check if a user is an admin
             *
             * @return {Boolean}
             */
            isAdmin: function() {
                //  console.log('4444');
                // User.getCurrent().
                return false;
            },

            logout: function() {
                currentUser = null;
                return User.logout()
            }
        };
    });
